import { render } from "./paginated-counter.vue?vue&type=template&id=7a2c7e14&scoped=true&ts=true"
import script from "./paginated-counter.vue?vue&type=script&lang=ts"
export * from "./paginated-counter.vue?vue&type=script&lang=ts"

import "./paginated-counter.vue?vue&type=style&index=0&id=7a2c7e14&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a2c7e14"]])

export default __exports__